export default __webpack_public_path__ + "static/media/prospect1.79aee9fb.jpg";